import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { ReceiveOrderAction } from './receive-order.actions';
import { ReceiveOrderService } from '../services/receive-order.service';

@Injectable()
export class ReceiveOrderEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly logger: NGXLogger,
    private readonly receiveOrderService: ReceiveOrderService
  ) {}

  cashSettlementListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReceiveOrderAction.receiveOrderViewRequest),
      tap((_) => this.logger.debug('@Effect [Receive Order] receive order view request')),
      switchMap(({ payload }) => {
        return this.receiveOrderService.getReceiveOrderView(payload).pipe(
          map((response) => {
            return ReceiveOrderAction.receiveOrderViewResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  receiveOrderListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReceiveOrderAction.receiveOrderListRequest),
      tap((_) => this.logger.debug('@Effect [Receive Order] Receive Order list request ')),
      switchMap(({ payload }) => {
        return this.receiveOrderService.list({ ...payload }).pipe(
          map((response) => {
            return ReceiveOrderAction.receiveOrderListResponse({ response });
          }),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
